import { gql } from '@apollo/client';

export const READ_BENEFITS = gql`
  query ReadBenefits {
    readBenefits {
      uid
      memberGroupUid
      benefitTargetUid
      benefitTargetType
      maxNumberOfActiveBenefits
      name
      customerUidB2B
      customerMemberMetadata {
        validity {
          validFrom
          validTo
        }
        admissionDetails {
          admission {
            type
            uid
          }
          attributes {
            verificationSubjectId
            verifiedAt
          }
        }
      }
      countryCode
      logo
      pmc {
        physicalZoneUid
        salesLocationUid
        salesLocation {
          uid
          name
          parkingZones
          description
        }
      }
    }
  }
`;
